import React, { useState,useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Modal
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid, GridColDef, GridRowModes, GridRowModesModel } from '@mui/x-data-grid';
import { Box } from "@mui/material";
import "./UserManagement.css";

import { GridActionsCellItem } from "@mui/x-data-grid";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { deleteModelManagementDetails , getModelManagementDetails, insertModelDetails } from "../../../../src/api/api";



import "../admin.scss"
import { set } from "lodash";

const ModelManagement = () => {
   const [voiceEnabled, setVoiceEnabled] = useState("no");
  const [isActiveEnabled, setisActiveEnabled] = useState("yes")
  const [errors, setErrors] = useState<any>({});

 // const [row, setRow] = React.useState(rows);
  // const [rowModesModel, setRowModesModel] = React.useState({});
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState<number | null>(null);
  
  const [modelData, setModelData] = useState<any[]>([]);
  const [category, setCategory] = useState("");
const [modelProvider, setModelProvider] = useState("");
const [modelDisplayName, setModelDisplayName] = useState("");
const [modelName, setModelName] = useState("");
const [modelId, setModelId] = useState("");
const [tokenLimit, setTokenLimit] = useState("");
const [inputCost, setInputCost] = useState("");
const [outputCost, setOutputCost] = useState("");
const [voiceInputCost, setVoiceInputCost] = useState("");
const [voiceOutputCost, setVoiceOutputCost] = useState("");
const [tableLoading, setTableLoading] = useState(false);
const [saving, setSaving] = useState(false);



const validateForm = () => {
  const newErrors: any = {};

  if (!category) {
    newErrors.category = "Category is required";
  }

  if (!modelProvider) {
    newErrors.modelProvider = "Model Provider is required";
  }

  if (!modelDisplayName.trim()) {
    newErrors.modelDisplayName = "Model Display Name is required";
  }

  if (!modelName.trim()) {
    newErrors.modelName = "Name is required";
  }

  if (!modelId.trim()) {
    newErrors.modelId = "Model Id is required";
  }

  if (!tokenLimit) {
    newErrors.tokenLimit = "Token Limit is required";
  } else if (Number(tokenLimit) <= 0) {
    newErrors.tokenLimit = "Must be greater than 0";
  }

  if (!inputCost) {
    newErrors.inputCost = "Input Cost is required";
  } else if (Number(inputCost) < 0) {
    newErrors.inputCost = "Cannot be negative";
  }

  if (!outputCost) {
    newErrors.outputCost = "Output Cost is required";
  } else if (Number(outputCost) < 0) {
    newErrors.outputCost = "Cannot be negative";
  }

  if (voiceEnabled === "yes") {
    if (!voiceInputCost) {
      newErrors.voiceInputCost = "Voice Input Cost is required";
    }

    if (!voiceOutputCost) {
      newErrors.voiceOutputCost = "Voice Output Cost is required";
    }
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
  

  const [rowModesModel, setRowModesModel] =
  React.useState<GridRowModesModel>({});
  
  const handleEditClick = (id: number) => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.Edit },
    });
  };


  useEffect(() => {
  loadModels();
}, []);


const handleSaveModel = async () => {
    if (!validateForm()) {
    return;
  }
  try {
    const payload = {
      Name: modelName, 
      Display_Name: modelDisplayName,
      Input_Cost: Number(inputCost),
      Output_Cost: Number(outputCost),
      Is_Active: isActiveEnabled === "yes" ? 1 : 0,
      Token_Limit_Per_Day: Number(tokenLimit),
      Model_Provider: modelProvider,
      Model_id: modelId,
      Category: category,
      is_Voice_Enabled: voiceEnabled === "yes" ? 1 : 0,
      voice_input_rate:
        voiceEnabled === "yes"
          ? Number(voiceInputCost)
          : 0,
      voice_output_rate:
        voiceEnabled === "yes"
          ? Number(voiceOutputCost)
          : 0,
    };
console.log("Model Provider:", modelProvider);
console.log("Payload:", payload);
  

    const result = await insertModelDetails(payload);

    alert(result.message);
    await loadModels();
    setModelName("");
    setModelDisplayName("");
    setInputCost("");
    setOutputCost("");
    setTokenLimit("");
    setModelProvider("");
    setModelId("");
    setCategory("");
    setVoiceEnabled("no");
    setVoiceInputCost("");
    setVoiceOutputCost("");


  } catch (error: any) {
    console.error(error);
    alert(error.message);
  }
};


const ChatStyleLoader = ({ compact = false }: { compact?: boolean }) => (
  <div
    className={
      compact
        ? "userManagementChatLoader userManagementChatLoaderCompact"
        : "userManagementChatLoader"
    }
  >
    <i className="userManagementChatLoaderLogo">
      <svg
        width="32"
        height="18"
        viewBox="0 0 58 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="logopath1"
          d="M55.0589 4.27963C54.4429 4.27963 53.9133 4.0797 53.4702 3.67984C53.0379 3.27997 52.8218 2.77204 52.8218 2.15603C52.8218 1.54002 53.0379 1.02668 53.4702 0.616008C53.9133 0.205336 54.4429 0 55.0589 0C55.6965 0 56.2368 0.205336 56.6799 0.616008C57.123 1.02668 57.3446 1.54002 57.3446 2.15603C57.3446 2.73961 57.123 3.24215 56.6799 3.66363C56.2368 4.0743 55.6965 4.27963 55.0589 4.27963ZM56.9231 22.4843C56.9231 23.5228 56.0812 24.3647 55.0426 24.3647C54.0041 24.3647 53.1622 23.5228 53.1622 22.4843V9.64539C53.1622 8.60684 54.0041 7.76494 55.0426 7.76494C56.0812 7.76494 56.9231 8.60684 56.9231 9.64538V22.4843Z"
        ></path>
        <path
          id="logopath2"
          d="M37.2763 21.3745C37.2683 21.3616 37.2541 21.3535 37.2389 21.3535C37.2148 21.3535 37.1952 21.3731 37.1952 21.3973V30.0221C37.1952 31.1145 36.3096 32 35.2173 32C34.1249 32 33.2393 31.1144 33.2393 30.0221V8.38873C33.2393 7.29634 34.1249 6.4108 35.2173 6.4108H35.6547C36.5055 6.4108 37.1952 7.1005 37.1952 7.95128V9.44848C37.1952 9.47239 37.2146 9.49177 37.2385 9.49177C37.2539 9.49177 37.2682 9.48341 37.276 9.47009C38.6284 7.1567 40.6021 6 43.1972 6C45.4138 6 47.1417 6.78165 48.3807 8.34496C49.6198 9.90827 50.2393 12.0079 50.2393 14.6438C50.2393 17.5651 49.5402 19.9043 48.142 21.6616C46.7438 23.4189 44.8341 24.2976 42.4128 24.2976C40.1928 24.2976 38.4806 23.3232 37.2763 21.3745ZM37.1611 14.4384V16.6122C37.1611 17.8903 37.5646 18.9743 38.3717 19.8644C39.1902 20.7544 40.2246 21.1995 41.475 21.1995C42.9414 21.1995 44.0895 20.6289 44.9194 19.4878C45.7605 18.3353 46.1811 16.7321 46.1811 14.6781C46.1811 12.955 45.789 11.6085 45.0046 10.6386C44.2316 9.65723 43.1801 9.16656 41.8502 9.16656C40.4406 9.16656 39.3038 9.66864 38.4399 10.6728C37.5874 11.677 37.1611 12.9322 37.1611 14.4384Z"
          fill="#0D0D0D"
        ></path>
        <path
          id="logopath3"
          d="M25.9636 23.0058C25.9623 22.9454 25.9369 22.8879 25.8925 22.8452C25.8481 22.8025 25.7882 22.778 25.7254 22.7768L18.6226 22.7775C18.617 22.7775 18.6123 22.7745 18.6067 22.7745C18.5738 22.7726 18.5413 22.767 18.5098 22.7577C18.4886 22.7538 18.4678 22.7484 18.4475 22.7413C18.418 22.7269 18.3904 22.7091 18.3653 22.6882C18.3486 22.6776 18.3327 22.6659 18.3177 22.6531C18.2957 22.6284 18.2766 22.6014 18.2609 22.5726C18.2503 22.5569 18.2407 22.5406 18.2324 22.5237C18.2296 22.5172 18.222 22.5138 18.2212 22.5054L16.095 16.4468C15.987 16.0827 15.9708 15.699 16.0478 15.3277C16.1248 14.9563 16.2927 14.608 16.5376 14.3114L21.3062 8.54369C21.4474 8.37108 21.6283 8.2322 21.8346 8.13792C22.0409 8.04364 22.2671 7.99651 22.4956 8.0002L22.4979 8.00249L22.5003 8.0002L22.5087 8.00211C22.7074 7.99972 22.9047 8.03565 23.0888 8.10775C23.2729 8.17986 23.4401 8.28669 23.5805 8.42194C23.6215 8.46137 23.6601 8.50304 23.696 8.54675L28.4638 14.313C28.7101 14.6124 28.8782 14.9642 28.9541 15.3389C29.03 15.7136 29.0115 16.1003 28.9001 16.4667L27.8977 19.3235C27.8803 19.3742 27.8527 19.4211 27.8163 19.4615C27.78 19.5019 27.7357 19.535 27.6861 19.5588C27.6364 19.5827 27.5823 19.5969 27.5269 19.6006C27.4715 19.6043 27.4159 19.5974 27.3632 19.5803C27.3106 19.5632 27.262 19.5363 27.2202 19.5011C27.1785 19.4659 27.1444 19.4231 27.1199 19.3752C27.0954 19.3273 27.081 19.2752 27.0776 19.2219C27.0741 19.1686 27.0817 19.1152 27.0998 19.0647L28.0962 16.2259C28.1674 15.9856 28.1781 15.7326 28.1273 15.4876C28.0766 15.2426 27.9659 15.0128 27.8044 14.8171L23.0414 9.04787C23.007 9.00751 22.9677 8.97125 22.9243 8.93986V14.1122C23.4502 14.2126 23.9185 14.4976 24.238 14.9116C24.5575 15.3256 24.7054 15.8391 24.6529 16.3521C24.6004 16.8651 24.3513 17.3411 23.954 17.6873C23.5567 18.0335 23.0397 18.2253 22.5035 18.2253C21.9673 18.2253 21.4503 18.0335 21.053 17.6873C20.6557 17.3411 20.4066 16.8651 20.3541 16.3521C20.3016 15.8391 20.4495 15.3256 20.769 14.9116C21.0885 14.4976 21.5568 14.2126 22.0827 14.1122L22.0823 8.93872C22.0391 8.97068 22.0004 9.00788 21.9672 9.0494L17.1978 14.8141C17.0377 15.0072 16.9273 15.2339 16.8758 15.4758C16.8243 15.7177 16.833 15.968 16.9013 16.206L18.9259 21.9692L25.727 21.9669C25.8688 21.9668 26.0092 21.9935 26.1402 22.0456C26.2712 22.0977 26.3903 22.1742 26.4905 22.2706C26.5908 22.367 26.6703 22.4814 26.7245 22.6074C26.7787 22.7333 26.8065 22.8683 26.8064 23.0046L26.8068 24.9599C26.8067 25.2352 26.6929 25.4992 26.4904 25.6939C26.2879 25.8885 26.0134 25.9979 25.727 25.998L16.8519 25.9999C16.796 26.0009 16.7405 25.9911 16.6885 25.9712C16.6366 25.9513 16.5893 25.9217 16.5494 25.884C16.5095 25.8464 16.4778 25.8015 16.4562 25.7519C16.4345 25.7023 16.4233 25.6491 16.4233 25.5954C16.4233 25.5416 16.4344 25.4884 16.456 25.4388C16.4776 25.3892 16.5092 25.3443 16.5491 25.3066C16.589 25.2689 16.6362 25.2392 16.6881 25.2193C16.7401 25.1993 16.7956 25.1895 16.8515 25.1904L25.7266 25.19C25.7579 25.1902 25.789 25.1844 25.818 25.1729C25.8469 25.1615 25.8733 25.1446 25.8954 25.1233C25.9176 25.102 25.9351 25.0767 25.947 25.0489C25.9589 25.021 25.965 24.9912 25.9648 24.961L25.9636 23.0058ZM21.575 17.0354C21.7586 17.2119 21.9926 17.3322 22.2473 17.3809C22.502 17.4296 22.7661 17.4046 23.006 17.309C23.246 17.2135 23.4511 17.0517 23.5953 16.8441C23.7396 16.6364 23.8167 16.3924 23.8167 16.1427C23.8167 15.893 23.7396 15.6489 23.5953 15.4413C23.4511 15.2336 23.246 15.0718 23.006 14.9763C22.7661 14.8807 22.502 14.8557 22.2473 14.9044C21.9926 14.9531 21.7586 15.0734 21.575 15.2499C21.329 15.4868 21.1908 15.8079 21.1908 16.1427C21.1908 16.4774 21.329 16.7985 21.575 17.0354Z"
          fill="#DA2128"
          stroke="#DA2128"
          strokeWidth="0.9"
        ></path>
        <circle
          id="logopathcircle"
          cx="23.2471"
          cy="2.24705"
          r="2.24705"
          fill="#DA2128"
        ></circle>
        <path
          id="logopath5"
          d="M14 25.2513C14 26.2171 13.2171 27 12.2513 27H2C0.895431 27 0 26.1046 0 25V2C0 0.895431 0.895431 0 2 0H2.19647C3.30104 0 4.19647 0.895431 4.19647 2V21.5026C4.19647 22.6071 5.0919 23.5026 6.19647 23.5026H12.2513C13.2171 23.5026 14 24.2855 14 25.2513Z"
          fill="#0D0D0D"
        ></path>
      </svg>
    </i>

    <div
      className={
        compact
          ? "userManagementChatLoaderSpinner"
          : "userManagementChatLoaderSpinner userManagementChatLoaderSpinnerLarge"
      }
    ></div>
  </div>
);


const loadModels = async () => {
    setTableLoading(true);
  try {
    const response = await getModelManagementDetails();

    const list = response?.data || [];   

    console.log("API Response:", response);

    const formattedRows = list.map((item: any, index: number) => ({
      
      id: item.ID,
      category: item.Category,
      provider: item.Model_Provider,
      modelName: item.Display_Name,
      modelId: item.Model_id,
      tokenPerDay: item.Token_Limit_Per_Day,
      inputCost: item.Input_Cost,
      outputCost: item.Output_Cost,
      isActive: item.Is_Active ,
      remainingTokens: item.Remaining_Tokens,
      isVoice: item.Is_Voice_Enabled ,
      voiceInputCost: item.voice_input_rate,
      voiceOutputCost: item.voice_output_rate,
    }));
  

    console.log("Fetched Models:", formattedRows);

    setModelData(formattedRows);
  } catch (error) {
    console.error("Failed to load models:", error);
  } finally{
    setTableLoading(false);
  }
};

// const loadModels = async () => {
//   try {
//     const data = await getModelManagementDetails();
//     console.log("API Response:", data);
//     const formattedRows = data.map((item: any, index: number) => ({
//       id: item.Model_Id || index + 1,
//       category: item.Category,
//       provider: item.Model_Provider,
//       modelName: item.Display_Name,
//       modelId: item.Model_id,
//       tokenPerDay: item.Token_Limit_Per_Day,
//       inputCost: item.Input_Cost,
//       outputCost: item.Output_Cost,
//       isActive: item.Is_Enabled === 1,
//       remainingTokens: item.Remaining_Tokens,
//       isVoice: item.is_Voice_Enabled === 1,
//       voiceInputCost: item.voice_input_rate,
//       voiceOutputCost: item.voice_output_rate,
//     }));

//     console.log("Fetched Models:", formattedRows);

//     setModelData(formattedRows);
//   } catch (error) {
//     console.error("Failed to load models:", error);
//   }
// };

  const handleSaveClick = (id: number) => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View },
    });
  };

  const handleDeleteClick = (id: number) => {
    setSelectedId(id);
    setOpenDialog(true);
  };

  // const handleConfirmDelete = () => {
  //   setModelData(modelData.filter((row) => row.id !== selectedId));
  //   setOpenDialog(false);
  // };

  const handleConfirmDelete = async () => {

  try {
 

    const res = await deleteModelManagementDetails(selectedId);


    setModelData((prev) => {
      const updated = prev.filter((row) => row.id !== selectedId);
      console.log(" Updated rows after delete:", updated);
      return updated;
    });

    setOpenDialog(false);
    setSelectedId(null);

    console.log(" Delete completed successfully");
  } catch (error) {
    console.error(" Delete failed:", error);
  }
};

//   const handleConfirmDelete = async () => {
//   try {
//     await deleteModelManagementDetails(selectedId);

    
//     setModelData((prev) =>
//       prev.filter((row) => row.id !== selectedId)
//     );

//     setOpenDialog(false);
//     setSelectedId(null);

//     alert("Deleted successfully");
//   } catch (error: any) {
//     console.error("Delete failed:", error);
//     alert(error.message);
//   }
// };

  const handleCancelClick = (id: number) => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  
  const handleProcessRowUpdate = (newRow: any) => {
    const updatedRows = modelData.map((row) =>
      row.id === newRow.id ? newRow : row
    );
    setModelData(updatedRows);
    return newRow;
  };
  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 40,editable: true, },
    { field: "category", headerName: "Category",editable: true, },
    { field: "provider", headerName: "Provider",editable: true, },
    { field: "modelName", headerName: "Model Display Name", width: 150,editable: true, },
    { field: "modelId", headerName: "Model ID", width: 150,editable: true, },
    { field: "tokenPerDay", headerName: "Token Limit Per Day", width: 150,editable: true, },
    { field: "inputCost", headerName: "Input Cost($)", width: 150,editable: true, },
    { field: "outputCost", headerName: "Output Cost($)", width: 150,editable: true, },
    { field: "isActive", headerName: "Active", width: 100, editable: true, 
      renderCell: (params) => (
        
        <span
          className={
            params.value ? 'status-active' : 'status-inactive'
          }
        >
          {params.value ? 'Active' : 'Inactive'}
        </span>
      ),

    },
    // { field: "remainingTokens", headerName: "Remaining Tokens", width: 150,editable: true, },
    { field: "isVoice", headerName: "Voice", width: 90, editable: true,

      renderCell: (params) => (
        
        <span
          className={
            params.value ? 'status-active' : 'status-inactive'
          }
        >
          {params.value ? 'Active' : 'Inactive'}
        </span>
      ),

     },
    { field: "voiceInputCost", headerName: "Voice Input Cost($)", width: 150,editable: true, },
    { field: "voiceOutputCost", headerName: "Voice Output Cost($)", width: 150,editable: true, },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 120,
      getActions: (params:any) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === "edit";

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={() => handleSaveClick(params.id)}
              className="modelmgmt-action-btn"
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={() => handleCancelClick(params.id)}
              className="modelmgmt-action-btn deleteBtn"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={() => handleEditClick(params.id)}
            className="modelmgmt-action-btn"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDeleteClick(params.id)}
            className="modelmgmt-action-btn deleteBtn"
          />,
        ];
      },
    },

  ];


  return (
    <div>
      <Accordion >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className="modelMgmt-titleWrapper">
          <Typography variant="h4">Add New Model</Typography>
        </AccordionSummary>

        <AccordionDetails className="modelRequestForm">
          <Grid container spacing={2}>
            {/* Category */}  
            <Grid item xs={6} md={3} xl={4} >
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                {/* <Select label="Category">
                  <MenuItem value="text">App</MenuItem>
                  <MenuItem value="image">Model</MenuItem>
                </Select> */}

        <Select
          value={category}
          // onChange={(e) => setCategory(e.target.value)
            
          // }
          onChange={(e) => {
  setCategory(e.target.value);
  setErrors({ ...errors, category: "" });
}}
          label="Category"
          error={!!errors.category}
        >
          <MenuItem value="App">App</MenuItem>
          <MenuItem value="Model">Model</MenuItem>
        </Select>

              </FormControl>
     {errors.category && (
  <Typography color="error" variant="caption">
    {errors.category}
  </Typography>
)}
            </Grid>
            {/* Model Provider */}
            <Grid item xs={6} md={3} xl={4} >
              <FormControl fullWidth>
                <InputLabel>Model Provider</InputLabel>
             
               <Select
                  value={modelProvider}
                  // onChange={(e) => setModelProvider(e.target.value)}
                  onChange={(e) => {
  setModelProvider(e.target.value);
  setErrors({ ...errors, modelProvider: "" });
}}
                  label="Model Provider"
                  error={!!errors.modelProvider}
                >
                  <MenuItem value="OpenAI">OpenAI</MenuItem>
                  <MenuItem value="Azure">Azure</MenuItem>
                  <MenuItem value="Google">Google</MenuItem>
                </Select>
              </FormControl>
              {errors.modelProvider && (
  <Typography color="error" variant="caption">
    {errors.modelProvider}
  </Typography>
)}
  </Grid>


            {/* Model Name */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Model Display Name"
               value={modelDisplayName}
              //  onChange={(e) => setModelDisplayName(e.target.value)}
              onChange={(e) => {
  setModelDisplayName(e.target.value);
  setErrors({ ...errors, modelDisplayName: "" });
}}
                 error={!!errors.modelDisplayName}
   />
               {errors.modelDisplayName && (
  <Typography color="error" variant="caption">
    {errors.modelDisplayName}
  </Typography>
)}
</Grid>

            {/* Model Id */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Model Id"
               value={modelId}
              //  onChange={(e) => setModelId(e.target.value)} 
                  onChange={(e) => {
                    setModelId(e.target.value);
                    setErrors({ ...errors, modelId: "" });
                  }}
                 error={!!errors.modelId}/>
                                          {errors.modelId && (
  <Typography color="error" variant="caption">
    {errors.modelId}
  </Typography>
)}
            </Grid>
  

            {/* Token */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Token Limit Per Day" 
               value={tokenLimit}
                    type="number"
              //  onChange={(e) => setTokenLimit(e.target.value)}
              onChange={(e) => {
  setTokenLimit(e.target.value);
  setErrors({ ...errors, tokenLimit: "" });
}}
               error={!!errors.tokenLimit}

               />
                       
{errors.tokenLimit && (
  <Typography color="error" variant="caption">
    {errors.tokenLimit}
  </Typography>
)}
            </Grid>

            {/* Input Cost */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Input Cost ($)"
               value={inputCost}
               type="number"
            //  onChange={(e) => setInputCost(e.target.value)} 
            onChange={(e) => {
  setInputCost(e.target.value);
  setErrors({ ...errors, inputCost: "" });
}}
                error={!!errors.inputCost}
             />
             {errors.inputCost && (
  <Typography color="error" variant="caption">
    {errors.inputCost}
  </Typography>
)}
            </Grid>

            {/* Output Cost */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Output Cost ($)"
                type="number"
               value={outputCost}
                // onChange={(e) => setOutputCost(e.target.value)} 
                onChange={(e) => {
  setOutputCost(e.target.value);
  setErrors({ ...errors, outputCost: "" });
}}
                  error={!!errors.outputCost}
                />
  {errors.outputCost && (
  <Typography color="error" variant="caption">
    {errors.outputCost}
  </Typography>
)}
 </Grid>

            <Grid item xs={6} md={3} xl={4} >
              <TextField fullWidth label="Name"
              //  value={modelName}
              //  onChange={(e) => setModelName(e.target.value)}
                onChange={(e) => {
      setModelName(e.target.value);
      setErrors({ ...errors, modelName: "" });
    }}
                  error={!!errors.modelName}
   />
     {errors.modelName && (
  <Typography color="error" variant="caption">
    {errors.modelName}
  </Typography>
)}
            </Grid>

            {/* Is Active */}
            <Grid item xs={6} md={3} xl={4} >
              <FormControl className="modelMgmt-radiowrapper">
                <FormLabel>Is Active</FormLabel>
                <RadioGroup row value={isActiveEnabled}
                  onChange={(e) => setisActiveEnabled(e.target.value)}>
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>

            {/* Token Limit Pending */}
            {/* <Grid item xs={12} md={3}>
            <TextField fullWidth label="Token Limit Pending" />
          </Grid> */}


            {/* Document Valid */}
            {/* <Grid item xs={12} md={3}>
            <FormControl className="modelMgmt-radiowrapper">
              <FormLabel>Is Document</FormLabel>
              <RadioGroup row>
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid> */}


            {/* Video Enable */}
            <Grid item xs={6} md={3} xl={4} >
              <FormControl className="modelMgmt-radiowrapper">
                <FormLabel>Voice Enable</FormLabel>
                <RadioGroup
                  row
                  value={voiceEnabled}
                  onChange={(e) => setVoiceEnabled(e.target.value)}
                > <FormControlLabel value="no" control={<Radio />} label="No" />
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />

                </RadioGroup>
              </FormControl>
            </Grid>

            {/* Conditional Fields */}
            <Grid item xs={6} md={3} xl={4} >
              <TextField
                fullWidth
                label="Voice Input Cost($)"
                  type="number"
                 value={voiceInputCost}
                 onChange={(e) => setVoiceInputCost(e.target.value)}  
                 disabled={voiceEnabled !== "yes"}
              />
            </Grid>

            <Grid item xs={6} md={3} xl={4} >
              <TextField
                fullWidth
                label="Voice Output Cost($)"
                  type="number"
                value={voiceOutputCost}
                onChange={(e) => setVoiceOutputCost(e.target.value)}
                disabled={voiceEnabled !== "yes"}
              />
            </Grid>
       
          </Grid>

          <div className="modelMgmt-actionWrapper">
            <Button variant="contained" className="close-btn-usermgmt" >
              Close
            </Button>
            {/* <Button variant="contained" className="save-btn-usermgmt">
              Save
            </Button> */}

           <Button
                variant="contained"
                className="save-btn-usermgmt"
                onClick={handleSaveModel}
              >
                Save
              </Button>
          </div>
        </AccordionDetails>
      </Accordion>

      <Box className="modelList-wrapper" sx={{ width: "100%", mt: 2 }}>
        <Typography variant="h6">Models List</Typography>
      </Box>

      {/* <Box sx={{ width: "100%", mt: 1 }}> */}
       <Box
              className="usermanagement-tablecontainer"
              style={{ height: 460, width: "100%", position: "relative" }}
            >
        {/* <Box sx={{ height: 400 }}> */}
        <Box
  sx={{
    height: 400,
    position: "relative",
  }}
>
  {tableLoading && (
    <div className="userManagementTableLoader">
      <ChatStyleLoader />
    </div>
  )}
          <DataGrid className="modelList-gridwrapper"
           // rows={rows}
             rows={modelData}
            columns={columns}
            rowHeight={37}
            columnHeaderHeight={42}
            pageSizeOptions={[10, 20, 50]}
           

            editMode="row"
            processRowUpdate={ handleProcessRowUpdate }
            // onRowEditStop={ handleRowEditStop }
            rowModesModel={rowModesModel}
            onRowModesModelChange={setRowModesModel}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
              
            }}
            //checkboxSelection
            disableColumnFilter
            disableColumnMenu
            disableRowSelectionOnClick
          />
        </Box>
      </Box>



             {/* delete MODAL */}
            <Modal open={openDialog} onClose={() => setOpenDialog(false)}>
              <Box className="userandmodal-mgmtmodal-box"
                sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 400,
                      bgcolor: 'background.paper',
                      boxShadow: 24,
                      p: 2,
                      borderRadius: 2,
                      margin:0,
                    }}
      >
                <div className="modal-header">
                  Delete Confirmation
                </div>
      
                <p>Are you sure you want to delete this row?</p>
      
                <div className="modal-footer">
                  <Button
                    variant="outlined" className="close-btn-usermgmt"
                    onClick={() => setOpenDialog(false)}
                  >
                    Cancel
                  </Button>
      
                  <Button
                    variant="contained"
                    color="error"
                     onClick={handleConfirmDelete}
                    className="save-btn-usermgmt"
                  >
                    Delete
                  </Button>
                </div>
              </Box>
            </Modal>
    </div>
  );
};

export default ModelManagement;